/**
 * UpdateNoticeBanner — Mitarbeiter-Hinweis auf neue Datenstände (v0.4.0).
 *
 * Lädt einmal GET /api/updates/notice. Bei offenen Funden erscheint ein dezenter
 * Balken; "Schließen" merkt sich den aktuellen Titel-Stand in localStorage, ein
 * geänderter Stand (neuer Fund) blendet den Balken wieder ein. Fehler → still nichts.
 */

import { useEffect, useState } from 'react'
import { X } from 'lucide-react'

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8899'
const DISMISS_KEY = 'update-notice-dismissed'

function readDismissed(): string | null {
  try {
    return localStorage.getItem(DISMISS_KEY)
  } catch {
    return null
  }
}

export default function UpdateNoticeBanner() {
  const [titles, setTitles] = useState<string[]>([])
  const [dismissed, setDismissed] = useState<string | null>(readDismissed)

  useEffect(() => {
    let cancelled = false
    fetch(`${API_BASE}/api/updates/notice`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled && data?.has_updates && Array.isArray(data.titles)) {
          setTitles(data.titles)
        }
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [])

  if (titles.length === 0) return null
  const stand = titles.join('|')
  if (dismissed === stand) return null

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, stand)
    } catch {
      /* ignorieren */
    }
    setDismissed(stand)
  }

  return (
    <div
      role="status"
      className="relative flex items-center justify-between gap-4 px-4 py-2 text-sm"
      style={{
        backgroundColor: 'var(--g8-bg-muted)',
        borderBottom: '1px solid var(--g8-primary)',
      }}
    >
      <span>
        Neue Daten für {titles.join(', ')} liegen vor, bitte an den Administrator wenden.
      </span>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Hinweis schließen"
        className="shrink-0 p-1 rounded hover:opacity-70"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  )
}
